export function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}
export function isValidPhone(phone) {
    const phoneRegex = /^\+?[\d\s-()]{7,20}$/;
    return phoneRegex.test(phone);
}
export function isNonEmptyString(value) {
    return typeof value === "string" && value.trim().length > 0;
}
export const DISPLAY_NAME_MAX = 255;
export const GUEST_NOTE_MAX = 2000;
export function guestTextMax(options = {}) {
    if (options.maxLength != null)
        return options.maxLength;
    return options.multiline ? GUEST_NOTE_MAX : DISPLAY_NAME_MAX;
}
const KEPT_FORMAT = new Set(["\u200D", "\uFE0E", "\uFE0F"]);
function isUnsafeGuestChar(ch, multiline) {
    if (ch === "\n")
        return !multiline;
    if (ch === "<" || ch === ">" || ch === "&")
        return true;
    if (KEPT_FORMAT.has(ch))
        return false;
    return /[\p{Cc}\p{Zl}\p{Zp}\p{Cf}]/u.test(ch);
}
/** Drop characters that are unsafe to store and show. Surrounding spaces stay so typing still works. */
export function restrictGuestText(raw, options = {}) {
    const multiline = options.multiline ?? false;
    const maxLength = guestTextMax(options);
    const source = multiline
        ? raw.replace(/\r\n/g, "\n").replace(/\r/g, "\n")
        : raw.replace(/[\r\n\u2028\u2029]/g, "");
    let out = "";
    for (const ch of source) {
        if (!isUnsafeGuestChar(ch, multiline))
            out += ch;
    }
    const chars = Array.from(out);
    if (chars.length > maxLength)
        return chars.slice(0, maxLength).join("");
    return out;
}
/** Text ready to store: unsafe characters removed and ends trimmed. */
export function sanitizeGuestText(raw, options = {}) {
    return restrictGuestText(raw, options).trim();
}
/** True when trimming is the only change needed before storing. */
export function isSafeGuestText(raw, options = {}) {
    if (typeof raw !== "string")
        return false;
    const trimmed = raw.trim();
    if (Array.from(trimmed).length > guestTextMax(options))
        return false;
    return restrictGuestText(trimmed, options) === trimmed;
}
//# sourceMappingURL=validation.js.map